module.exports = __webpack_public_path__ + "img/fg2.ac69f789.jpg";